export default __webpack_public_path__ + "static/media/saloon.ab9f1736.svg";